import { FieldBase } from '@/components/form/fieldBase';
import { useFieldContext } from '@/components/form/formHooks';
import { FieldProps } from '@/components/form/types';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
  InputProps,
} from '@e2n/ui';
import { maskitoNumber, MaskitoNumberParams } from '@maskito/kit';
import { useMaskito } from '@maskito/react';

export function FieldNumberInput({
  label,
  description,
  isRequired,
  placeholder,
  className,
  infoText,
  suffix,
  maskitoNumberParams,
  ...inputProps
}: FieldProps &
  InputProps & { suffix?: string; maskitoNumberParams: MaskitoNumberParams }) {
  const field = useFieldContext<string | undefined>();
  const inputRef = useMaskito({ options: maskitoNumber(maskitoNumberParams) });

  return (
    <FieldBase
      label={label}
      isRequired={isRequired}
      description={description}
      infoText={infoText}>
      <InputGroup>
        <InputGroupInput
          id={field.name}
          placeholder={placeholder}
          autoComplete="off"
          className={`h-10 ${className ?? ''}`}
          ref={inputRef}
          inputMode="decimal"
          value={field.state.value ?? ''}
          onChange={(e) => {
            field.handleChange(e.target.value);
          }}
          onBlur={field.handleBlur}
          {...inputProps}
        />
        {suffix && (
          <InputGroupAddon
            className="text-neutrals-700 text-sm font-normal leading-5"
            align={'inline-end'}>
            {suffix}
          </InputGroupAddon>
        )}
      </InputGroup>
    </FieldBase>
  );
}
